import { AnalyticsMeta } from 'src/redux/modules/analytics';

interface SlideCarouselAction {
  type: 'SLIDE_CAROUSEL';
  meta: {
    analytics: AnalyticsMeta;
  };
}

export function slideCarousel({
  direction,
  location,
}: {
  direction: string;
  location: string;
}): SlideCarouselAction {
  return {
    type: 'SLIDE_CAROUSEL',
    meta: {
      analytics: {
        event: 'click',
        subtype: 'button',
        event_value: `carousel slide ${direction}`,
        page_section: location,
        activity_type: 'crowdfunding_guid',
      },
    },
  };
}

export default function reducer(state = {}, action: SlideCarouselAction) {
  switch (action.type) {
    case 'SLIDE_CAROUSEL':
    // fallthrough
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/carousel.ts